module.exports = __webpack_public_path__ + "static/media/2040314000.8bb223db.jpg";